import React from "react"
import styled, {css} from "styled-components"
import PropTypes from "prop-types"

import ButtonBase from "@irati/ui/src/Button"

import {SENTIMENT_BUTTON_SIZE, SENTIMENT_BUTTON_SIZE_MOBILE, SENTIMENT_ICON_SIZE, SENTIMENT_ICON_SIZE_MOBILE} from "../driver.constants"

const Button = styled(ButtonBase)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${SENTIMENT_BUTTON_SIZE}px;
  font-size: 10px;
  line-height: 15px;
  ${({theme, isActive}) => isActive && css`
    background-color: ${theme.colors.primary2};
    color: ${theme.colors.utility.white};
  `}
  
  ${({theme}) => theme.mediaQueries.maxWidthMedia.tablet`
    height: ${SENTIMENT_BUTTON_SIZE_MOBILE}px;
    padding: ${theme.spacing.one};
  `}
`
const Icon = styled.img`
  width: ${SENTIMENT_ICON_SIZE_MOBILE}px;
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    width: ${SENTIMENT_ICON_SIZE}px;
  `}
`

const Sentiment = ({id, icon, isActive, handleClick}) => {
  return (
    <Button onClick={() => handleClick(id)} isActive={isActive} full>
      <Icon src={icon} alt={id} />
    </Button>
  )
}

Sentiment.propTypes = {
  id: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired
}

export default Sentiment
